import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-all-send",
  "use": "icon-all-send-usage",
  "viewBox": "0 0 20 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 18\" id=\"icon-all-send\"><path d=\"M8.918 18a.738.738 0 0 1-.741-.732V12.86l.867-1.066c.017-.025.031-.047.048-.067l7.358-8.8-13.73 6.74 7.585 2.322-1 1.23-8.784-2.694a.75.75 0 0 1-.444-.379.73.73 0 0 1 .333-.984L18.926.077a.761.761 0 0 1 .33-.077.737.737 0 0 1 .733.87l-2.596 14.004a.746.746 0 0 1-.733.602h-.042a.799.799 0 0 1-.224-.033L9.66 13.356v3.909a.739.739 0 0 1-.742.735zm7.162-4.19l1.94-10.452-7.34 8.78 5.4 1.672z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol